module.exports = __webpack_public_path__ + "media/images/vehicle-avatar-large-ca85884f7314b176d792f4aa4160d2f4.svg";